/**
 * sync-runtime.ts — D42: cloud-sync runtime selection (Supabase-only).
 * Firebase project was deleted 2026-06-10; all Firebase code removed in D42.
 * Supabase configured → cloud sync; absent → pure local mode. UI/hooks consume ONLY this module.
 */
import type { LifeOsState } from "../types";
import type { RemoteSnapshotMeta } from "./supabase-sync-helpers";
import { supabaseSyncConfigStatus, supabaseSyncEnabled } from "./supabase-config";

/** The exact surface useLifeOs consumes. */
export interface CloudSyncRuntime {
  observeAuth: (
    onUser: (user: { uid: string; email: string | null } | null) => void,
    onError: () => void,
  ) => () => void;
  signIn: (email: string, password: string) => Promise<unknown>;
  signUp: (email: string, password: string) => Promise<unknown>;
  resetPassword: (email: string) => Promise<unknown>;
  signOutOfSync: () => Promise<unknown>;
  pushRemoteState: (uid: string, state: LifeOsState, mode?: string) => Promise<unknown>;
  subscribeToRemoteState: (
    uid: string,
    // meta mang updated_at của TỪNG row remote — nền tảng merge LWW per-item (F1).
    onState: (state: LifeOsState | null, meta: RemoteSnapshotMeta) => void,
    onError: () => void,
  ) => () => void;
}

export function cloudSyncEnabled(): boolean {
  return supabaseSyncEnabled();
}

export function cloudSyncConfigStatus() {
  return supabaseSyncConfigStatus();
}

export function loadCloudSyncRuntime(): Promise<CloudSyncRuntime> {
  return import("./supabase-sync") as Promise<CloudSyncRuntime>;
}
